import React from 'react';

export default class Copyright extends React.Component <any, any>{
    constructor(props: any) {
        super(props);
        this.state = {
          dataSetup: {},
        };
      }

    render() {
        return (
            <div className="row border-top pt-1">
                <div className="col-12 text-center">
                    {this?.props?.dataSetup?.copy_write}
                </div>
            </div>
        );
    }
}
